import { Icon } from '../../icon/icon.tsx'
import type { IconColor } from '../../icon/types/core.ts'

export const PageHeaderOverlineBreadcrumbDivider = ({
  iconColor = 'tertiary',
}: { iconColor: IconColor }) => (
  <Icon name="ChevronRightIcon" size="sm" color={iconColor} />
)
